/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Dialogue_TitlecaseInputs */

const en_ccsl_export_header_dialogue_titlecase = /** @type {(inputs: Ccsl_Export_Header_Dialogue_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogue`)
};

const fr_ccsl_export_header_dialogue_titlecase = /** @type {(inputs: Ccsl_Export_Header_Dialogue_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogue`)
};

const de_ccsl_export_header_dialogue_titlecase = /** @type {(inputs: Ccsl_Export_Header_Dialogue_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialog`)
};

const it_ccsl_export_header_dialogue_titlecase = /** @type {(inputs: Ccsl_Export_Header_Dialogue_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogo`)
};

const ru_ccsl_export_header_dialogue_titlecase = /** @type {(inputs: Ccsl_Export_Header_Dialogue_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Диалог`)
};

const es_ccsl_export_header_dialogue_titlecase = /** @type {(inputs: Ccsl_Export_Header_Dialogue_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diálogo`)
};

const zh_cn2_ccsl_export_header_dialogue_titlecase = /** @type {(inputs: Ccsl_Export_Header_Dialogue_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对话`)
};

const ja_ccsl_export_header_dialogue_titlecase = /** @type {(inputs: Ccsl_Export_Header_Dialogue_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対話`)
};

const hi_ccsl_export_header_dialogue_titlecase = /** @type {(inputs: Ccsl_Export_Header_Dialogue_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वार्ता`)
};

const pt_pt2_ccsl_export_header_dialogue_titlecase = /** @type {(inputs: Ccsl_Export_Header_Dialogue_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diálogo`)
};

/**
* | output |
* | --- |
* | "Dialogue" |
*
* @param {Ccsl_Export_Header_Dialogue_TitlecaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_dialogue_titlecase = /** @type {((inputs?: Ccsl_Export_Header_Dialogue_TitlecaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Dialogue_TitlecaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_dialogue_titlecase(inputs)
	if (locale === "de") return de_ccsl_export_header_dialogue_titlecase(inputs)
	if (locale === "it") return it_ccsl_export_header_dialogue_titlecase(inputs)
	if (locale === "ru") return ru_ccsl_export_header_dialogue_titlecase(inputs)
	if (locale === "es") return es_ccsl_export_header_dialogue_titlecase(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_dialogue_titlecase(inputs)
	if (locale === "ja") return ja_ccsl_export_header_dialogue_titlecase(inputs)
	if (locale === "hi") return hi_ccsl_export_header_dialogue_titlecase(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_dialogue_titlecase(inputs)
	return en_ccsl_export_header_dialogue_titlecase(inputs)
});